import React from "react";
import UserInvitedListState, { UserInvitedListProps } from "./UserInvitedList.models";
import './UserInvitedList.scss';
import UserReferrerService from "../../../services/management/UserReferrerService";
import UserReffererListImage from '../../../assest/images/card-image/ItemAvatar08.png';
export default class UserInvitedList extends React.PureComponent<UserInvitedListProps, UserInvitedListState> {
    userReferrerService: UserReferrerService;
    constructor(props: any) {
        super(props);
        this.userReferrerService = new UserReferrerService();
        this.state = { userReferrer: { rows: [], totalRowCount: 0 } }
    }

    componentDidMount = () => {
        let self = this;
        self.getData();
    }
    getData = () => {
        let self = this;

        self.userReferrerService.getPages({
            descendingOrder: true,
            orderField: "ID",
            pageSize: 10000,
            pageSkip: 0
        }).then(function (response) {
            self.setState({ userReferrer: response });
        });
    }

    render(): React.ReactNode {
        let { userReferrer } = this.state;

        return (<>
            <div className="col-12 notspace user-invited-list-area">

                <label>دوستان دعوت شده</label>
                {userReferrer.rows.map((user, key) => {
                    return (<div key={key} className="col-12 notspace margin-top">
                            <div className="tk-inline card-boundel">
                                <div className="col-2 notspace">
                                    <img className="icon" src={UserReffererListImage} width="56" height="72" alt="user-refferer list icon" />
                                </div>
                                <div className="col-7 notspace" style={{ textAlign: "right", marginRight: "20px" }}>
                                    <div className="pd-detail">
                                        <div className="box-title">
                                            <label>{user.fullName}</label>
                                        </div>
                                        <div className="box-subtitle">
                                            <label>{user.phoneNumber}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-2 notspace">
                                    {user.isJoined ? (<label className="mdi mdi-check-decagram icon-loc"></label>) : (<label className="mdi mdi-account-clock icon-loc"></label>)}
                                </div>
                            </div>
                        </div>)
                })}


            </div>
        </>);
    }
}